import React, { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Pages
import Dashboard from "@/pages/Dashboard";
import DataUpload from "@/pages/DataUpload";
import Students from "@/pages/Students";
import StudentReport from "@/pages/StudentReport";
import Mentors from "@/pages/Mentors";
import Resources from "@/pages/Resources";
import Login from "@/pages/Login";
import SharedReport from "@/pages/SharedReport";
import DashboardLayout from "@/components/DashboardLayout";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("mu_admin_token");
    if (token) {
      setIsAuthenticated(true);
    }
  }, []);

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem("mu_admin_token");
    setIsAuthenticated(false);
  };

  return (
    <div className="min-h-screen bg-white">
      <BrowserRouter>
        <Routes>
          {/* Public route for shared reports - no auth required */}
          <Route path="/report/share/:token" element={<SharedReport />} />
          
          <Route
            path="/login"
            element={
              isAuthenticated ? (
                <Navigate to="/" replace />
              ) : (
                <Login onLogin={handleLogin} />
              )
            }
          />
          
          <Route
            element={
              isAuthenticated ? (
                <DashboardLayout onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="/upload" element={<DataUpload />} />
            <Route path="/students" element={<Students />} />
            <Route path="/students/:studentId" element={<StudentReport />} />
            <Route path="/mentors" element={<Mentors />} />
            <Route path="/resources" element={<Resources />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
